import { memo, useRef, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { blueskyPostSelector } from 'services/compose/selectors'
import { AtpAgent, RichText } from '@atproto/api'
import { debounce } from 'shared'
import { setBlueSkyFacets, setMultipostBlueskyFacets } from 'services/compose'

const UPDATE_DEBOUNCE_TIME = 500

export const BlueskyFacetsSync = memo(({ multipostId, text }: { multipostId?: string, text?: string }) => {
  const dispatch = useDispatch()
  const post = useSelector(blueskyPostSelector)
  const agent$ = useRef<AtpAgent | null>(null)

  useEffect(() => {
    agent$.current = new AtpAgent({
      service: 'https://bsky.social'
    })
  }, [])

  useEffect(() => {
    const updateFacets = debounce(async (text: string) => {
      if (!agent$.current) {
        return
      }
      const rt = new RichText({ text })
      await rt.detectFacets(agent$.current)
      if (multipostId) {
        dispatch(setMultipostBlueskyFacets({ postId: multipostId, facets: rt.facets }))
      } else {
        dispatch(setBlueSkyFacets(rt.facets))
      }
    }, UPDATE_DEBOUNCE_TIME)

    const value = typeof text === 'string' ? text : post.status.text
    updateFacets(value)
  }, [post.status.text, multipostId, text, dispatch])

  return null
})
